$(document).ready(function () {
  // obecne
  var bodyWidth = window.innerWidth;

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }
  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    // AOS.refresh();
  });

  // události při scroolování
  $(window).on('scroll', function () {
    //...
  });

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    //new ModalVideo('.js-video-start', { channel: 'youtube' });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
      },
    });
  }

  // galerie
  if ($('.gallery').length) {
    $('.gallery a').simpleLightbox({
      showCounter: false,
    });
  }

  // manufacturer slider
  if ($('.manufacturer-slider').length) {
    jQuery('.manufacturer-slider__wrapper').slick({
      lazyLoad: 'ondemand',
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      fade: false,
      autoplay: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  }

  // scroll o 100% výšky okna při kliknutí
  if ($('.js-scroll').length) {
    $('.js-scroll').on('click', function (event) {
      event.preventDefault();
      $('html, body').animate(
        { scrollTop: window.scrollY + window.innerHeight },
        100
      );
    });
  }

  // skrývání toolbaru v hlavičce
  if ($('.toolbar').length) {
    toolbarHideOnScroll();
  }

  // auto animace
  if ($('.car').length) {
    carAnimation();
  }

  // často kladené otázky
  if ($('.faq').length) {
    faq();
  }

  // redirect from thx page
  if ($('#homepage-url').length) {
    thankYouPage();
  }

  if ($('.slider-simple').length) {
    jQuery('.slider-simple').slick({
      lazyLoad: 'ondemand',
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      //prevArrow: $('.slider__arrow-right'),
      //nextArrow: $('.slider__arrow-left'),
      cssEase: 'linear',
      fade: false,
      speed: 20000,
      autoplay: true,
      autoplaySpeed: 1000,
      variableWidth: true,
      adaptiveHeight: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            speed: 10000,
          },
        },
      ],
    });
  }
});
